import { Fragment, useState } from 'react';
import { Button, Input, Modal } from 'antd';
import styled from 'styled-components';

const { TextArea } = Input;

const StyledLinkButton = styled(Button)`
  font-size: 0.75rem !important;
  padding-left: 0 !important;
  height: unset !important;
  color: rgba(0, 0, 0, 0.65) !important;
  &:hover {
    color: rgba(3, 6, 8, 0.66) !important;
  }
`;

function stopPropagation(e) {
  e.stopPropagation();
}

export function EditComment({ comment, id, onEdit, loading }) {
  const [visible, setVisible] = useState(false);
  const [updatedComment, setUpdatedComment] = useState(null);

  const cancelEdit = () => {
    setVisible(false);
    setUpdatedComment(null);
  };

  const editComment = async () => {
    await onEdit({ id, comment: updatedComment });
    setVisible(false);
    setUpdatedComment(null);
  };

  return (
    <Fragment>
      <StyledLinkButton id="edit-comment-button" type="link" onClick={() => setVisible(true)}>
        <span>Edit</span>
      </StyledLinkButton>
      <Modal
        visible={visible}
        destroyOnClose
        title="Edit Comment"
        confirmLoading={loading}
        okText="Save Changes"
        okButtonProps={{
          id: 'confirm-edit-comment-button',
          disabled: !updatedComment,
          type: 'default',
        }}
        onOk={editComment}
        onCancel={cancelEdit}
      >
        <TextArea
          id="edit-comment-input"
          rows={4}
          onChange={e => setUpdatedComment(e.target.value)}
          onKeyDown={stopPropagation}
          onKeyUp={stopPropagation}
          defaultValue={comment}
        />
      </Modal>
    </Fragment>
  );
}
